import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ComponenteError from '../publicaciones/ComponenteError'

const REDIRECT_DELAY_MS = 5000

const PublicacionGrabada = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/Publicaciones/Administrar')
    }, REDIRECT_DELAY_MS)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div>
      <div className="row">
        <ComponenteError tipo="I" idAviso={18} />
      </div>
    </div>
  )
}

export default PublicacionGrabada
